import axios from "../axios";

export default class CommonServices{
    async getAllProperty(search_param = null, minify = 1)
    {
        let res = await axios.post(window.hostname + "api/auth/all-space", {
          limit: 100,
          device_type: 1,
          space_type: 1,
          search_param: search_param,
          status: 4,
          page: 1,
          minify: minify,
        });
        return res ; 
    }

    getCalculateData(avg_data,avg_past_data){
      let data_inc =null;
      let data_inc_status =true;
      if(avg_data >= avg_past_data){
         data_inc_status = true;
         if(avg_data == avg_past_data){
          data_inc = "+0.00";
        }
        else if(avg_data != 0 && avg_past_data == 0){
          data_inc ="+100.00";
        }
        else{
          data_inc= (((avg_data - avg_past_data) /avg_data) * 100).toFixed(2);
          data_inc=data_inc > 100 ? "+100" : "+" + data_inc;
        }         
      }
      else{
        data_inc_status =false;
        if(avg_data == 0 && avg_past_data != 0){
          data_inc = "-100.00";
        }
        else{
          data_inc =(((avg_past_data - avg_data)/ avg_past_data) * 100).toFixed(2);
          data_inc= data_inc >100 ? "-100.00" : "-" + data_inc;
        }
      }
      return{
        data_inc,
        data_inc_status
      } 
    }
}
